import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

export const title = 'Revenue by campaign (Chart)';

Total revenue generated by sales attributed to campaigns.

<CampaignAttributionDateNote />
